<div class="reset-page">
  <div class="reset-card br-card br-card-body">
    <h1 class="reset-title">Reset password</h1>

    <ng-container *ngIf="!token">
      <p class="reset-message">This reset link is missing its token. Request a new one from the sign-in screen.</p>
      <button type="button" class="br-btn br-btn--primary br-w-full reset-action" (click)="openSignIn()">
        Back to sign in
      </button>
    </ng-container>

    <ng-container *ngIf="token && !resetSucceeded">
      <form [formGroup]="resetForm" (ngSubmit)="submit()" class="reset-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>New password</mat-label>
          <input matInput formControlName="newPassword"
                 [type]="hidePassword ? 'password' : 'text'"
                 autocomplete="new-password" cdkFocusInitial />
          <button mat-icon-button matSuffix type="button"
                  (click)="hidePassword = !hidePassword"
                  [attr.aria-label]="hidePassword ? 'Show password' : 'Hide password'">
            <br-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</br-icon>
          </button>
          <mat-error *ngIf="resetForm.get('newPassword')?.hasError('required')">Password is required</mat-error>
          <mat-error *ngIf="resetForm.get('newPassword')?.hasError('minlength')">At least 8 characters</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Confirm password</mat-label>
          <input matInput formControlName="confirmPassword"
                 [type]="hidePassword ? 'password' : 'text'"
                 autocomplete="new-password" />
          <mat-error *ngIf="resetForm.get('confirmPassword')?.hasError('required')">Required</mat-error>
          <mat-error *ngIf="resetForm.hasError('mismatch') && resetForm.get('confirmPassword')?.touched">
            Passwords don't match
          </mat-error>
        </mat-form-field>

        <p *ngIf="serverError" class="br-alert br-alert--danger server-error" role="alert">{{ serverError }}</p>

        <button type="submit" class="br-btn br-btn--primary br-w-full reset-action" [disabled]="resetForm.invalid || submitting">
          {{ submitting ? 'Saving…' : 'Set new password' }}
        </button>
      </form>
    </ng-container>

    <ng-container *ngIf="resetSucceeded">
      <p class="reset-message">Your password has been updated.</p>
      <button type="button" class="br-btn br-btn--primary br-w-full reset-action" (click)="openSignIn()">
        Sign in
      </button>
    </ng-container>
  </div>
</div>
